import React from 'react'
import { Heading } from '@myxplor/ui'
import { startOfWeek, dayFormat } from '../../week'

import { fileNameWithDate } from '../../io/download-csv'
import { validateCCSStartDate } from './helpers'
import { CCSWeekInput } from './ccs-week-input'
import ReportForm from '../views/form'

const onSubmit = ({ gov_id, record_type }) => ({ remote_request }) => payload =>
  remote_request.submit({
    url: `${apiEndPoint({ gov_id, record_type })}?week_start_date=${payload.week_start_date}`,
    method: 'GET',
    fileName: fileNameWithDate('ISS Case Claims Payments Report'),
  })

const FormFields = ({ values, errors, onChange, valid }) => (
  <fieldset>
    <Heading small>Weekly ISS Case Claims Payments Report</Heading>
    <CCSWeekInput
      reportName="ISS Case Claims Payments"
      value={values.week_start_date}
      errors={errors.week_start_date}
      onChange={onChange}
      valid={valid}
    />
  </fieldset>
)

const apiEndPoint = ({ gov_id, record_type }) =>
  process.env.REACT_APP_API_HOST + `/api/${record_type}/${gov_id}/reports/iss-payments`

export const ReportIssCaseClaimPaymentsReport = ({ gov_id, record_type, resetCurrentReport }) => (
  <ReportForm
    formOptions={{
      validate: validateCCSStartDate,
      defaultValues: {
        week_start_date: dayFormat(startOfWeek()),
      },
    }}
    name="ISS Case Claims Payments Report"
    fieldsComponent={FormFields}
    resetCurrentReport={resetCurrentReport}
    onSubmit={onSubmit({ gov_id, record_type })}
  />
)



// WEBPACK FOOTER //
// ./src/reports/reports/iss-case-claims.jsx